import { Branding } from '../../branding.interface';

export const AAR_BRANDING: Branding = {
  termsAndConditionsURL: 'https://aar.co.ke/terms',
  privacyStatementURL: 'https://aar.co.ke/privacy-policy',
  pageTitle: 'AAR Member | Powered by M-TIBA',
  support: 'url',
  supportURL: 'https://aar.co.ke',
  healthTab: false,
  heidiProviderTab: false,
  providersTab: true,
  freshchat: false,
  bankCodesUrl: 'https://www.kba.co.ke/wp-content/uploads/2023/09/Bank-and-Branches-July-2023v.pdf',
  poweredBySvg: 'mtiba-logo.svg',
};
